import NewsletterCTA from "./NewsletterCTA";

export default function Footer() {
  return (
    <footer className="border-t-[3px] border-double border-ink mt-20 bg-bone" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-10 grid md:grid-cols-3 gap-8">
        <div>
          <img
            src="/logo-politicareal.png"
            alt="POLÍTICA REAL"
            className="h-20 w-auto"
            draggable="false"
          />
          <p className="mt-3 text-sm text-sub font-sans leading-relaxed">
            Agregador editorial de la política mexicana. Curaduría diaria de los principales diarios
            del país y concentrado de encuestas de la presidencia de la república.
          </p>
        </div>

        <div>
          <p className="section-eyebrow">Cobertura</p>
          <ul className="mt-3 space-y-1 text-sm text-ink font-sans">
            <li>Presidencia · Sheinbaum</li>
            <li>Congreso de la Unión</li>
            <li>32 entidades federativas</li>
            <li>Opinión y análisis</li>
            <li>México en el mundo</li>
          </ul>
        </div>

        <NewsletterCTA source="footer" variant="footer" />
      </div>

      <div className="border-t border-rule">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-3 flex flex-wrap items-center justify-between gap-3 text-[11px] font-mono uppercase tracking-widest text-sub">
          <p>© {new Date().getFullYear()} POLÍTICA REAL · Ciudad de México</p>
          <div className="flex flex-wrap gap-x-5 gap-y-1">
            <a href="/privacidad" className="hover:text-ink hover:underline" data-testid="footer-privacidad">
              Aviso de privacidad
            </a>
            <a href="mailto:contacto@politicareal.com" className="hover:text-ink hover:underline" data-testid="footer-contacto">
              contacto@politicareal.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
